import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h6l667zq: FaireBrandEntity = {
  token: "b_h6l667zq",
  type: "brand",
  name: "Girlie Girl Originals",
  avatarUrl: "https://cdn.faire.com/fastly/133528d75dc81d036f8b1986c1a673e1d250eadb60123991a602107d1d45080a.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/841c94868c611ebf421cefc5aebca3dfefbf5b423505a6928d1653c6b477008d.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/133528d75dc81d036f8b1986c1a673e1d250eadb60123991a602107d1d45080a.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/841c94868c611ebf421cefc5aebca3dfefbf5b423505a6928d1653c6b477008d.jpeg",
  location: "Booneville, MS, USA",
  minimumOrderDollars: 300,
  rating: 4.9,
  reviewCount: 563,
  isInsider: true,
  description: "At Girlie Girl Originals, we celebrate style, confidence, and a love for all things bold and fun! As a vibrant brand specializing in high-quality apparel, we bring your customers a diverse selection of fashion-forward designs with a southern flair.\nFrom sassy statements to patriotic pride and collegiate spirit, our collections blend comfort with creativity, ensuring every piece stands out. Whether you're looking for bold graphics or casual charm, Girlie Girl Originals is the go-to brand for those who love to express themselves through fashion.\nWe take pride in offering trendy collections tailored for boutiques and retailers seeking distinctive, trend-savvy apparel that their customers will love.\nJoin us in bringing fun, flair, and originality to every wardrobe! Please reach out to receive a copy of our MAP (minimum advertised price) policy. \n",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:44.987Z",
    importedBy: "entity-db-cli"
  }
};
